import { styles } from '@pinpoint/onpoint-charts';

import { MODEL_VIEW } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  model: {},
  fetchModelStatus: undefined,
  fetchModelError: undefined,

  remediateModelStatus: undefined,
  remediateModelError: undefined,

  downloadUrl: undefined,
  fetchDownloadUrlStatus: undefined,
  fetchDownloadUrlError: undefined,

  preInputDistDownloadUrl: undefined,
  fetchPreInputDistDownloadUrlStatus: undefined,
  fetchPreInputDistDownloadUrlError: undefined,

  postInputDistDownloadUrl: undefined,
  fetchPostInputDistDownloadUrlStatus: undefined,
  fetchPostInputDistDownloadUrlError: undefined,

  liftChartDownloadUrl: undefined,
  fetchLiftChartDownloadUrlStatus: undefined,
  fetchLiftChartDownloadUrlError: undefined,

  equalType: null,
  quantileIdx: null,
  availableQuantiles: {
    current: [],
  },
  quantiles: null,

  chart: CONSTANTS.TAL_MODEL.CHARTS.BAR_CHART,
  gradient: styles.Style1.COLORS.GRADIENTS.BLUE_ORANGE,

  roiCalculatorState: JSON.parse(CONSTANTS.TAL_MODEL.ROI_CALC_DEFAULTS) || {},
  disableInput: false,
  saveRoiCalculatorStateStatus: undefined,

  exportRoiCalculatorStatus: undefined,
  exportRoiCalculatorReady: false,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODEL_VIEW.RESET_PAGE:
      return INITIAL_STATE;
    case MODEL_VIEW.UNSET:
      return {
        ...state,
        [action.payload]: INITIAL_STATE[action.payload],
      };
    case MODEL_VIEW.SAVE_ROI_CALCULATOR_STATE:
      return {
        ...state,
        saveRoiCalculatorStateStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.SAVE_ROI_CALCULATOR_STATE_SUCCEEDED:
      return {
        ...state,
        saveRoiCalculatorStateStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.SAVE_ROI_CALCULATOR_STATE_FAILED:
      return {
        ...state,
        saveRoiCalculatorStateStatus: CONSTANTS.API.FAILED,
      };
    case MODEL_VIEW.EXPORT_ROI_CALCULATOR:
      return {
        ...state,
        exportRoiCalculatorStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.EXPORT_ROI_CALCULATOR_READY:
      return {
        ...state,
        exportRoiCalculatorReady: action.payload,
      };
    // NOTE: eliding export success because that will be indicated by the file being downloaded
    case MODEL_VIEW.EXPORT_ROI_CALCULATOR_FAILED:
      return {
        ...state,
        exportRoiCalculatorStatus: CONSTANTS.API.FAILED,
      };
    case MODEL_VIEW.INIT_ROI_CALCULATOR_STATE:
      return {
        ...state,
        roiCalculatorState: action.payload,
      };
    case MODEL_VIEW.SET_ROI_CALC_SEED_FROM_DATASET:
      return {
        ...state,
        dataset: action.payload,
      };
    case MODEL_VIEW.RESET_ROI_CALCULATOR_STATE_FIELD:
      // eslint-disable-next-line no-case-declarations
      const next = { ...state };
      next.roiCalculatorState[action.payload] = JSON.parse(CONSTANTS.TAL_MODEL.ROI_CALC_DEFAULTS)[action.payload];
      return next;
    case MODEL_VIEW.UPDATE_ROI_CALCULATOR_STATE:
      return {
        ...state,
        disableInput: true,
      };
    case MODEL_VIEW.UPDATE_ROI_CALCULATOR_STATE_SUCCEEDED:
      return {
        ...state,
        roiCalculatorState: { ...action.payload },
        disableInput: false,
      };
    case MODEL_VIEW.FETCH_MODEL:
      return {
        ...state,
        fetchModelStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.FETCH_MODEL_SUCCEEDED:
      return {
        ...state,
        model: action.payload,
        fetchModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.FETCH_MODEL_FAILED:
      return {
        ...state,
        fetchModelStatus: CONSTANTS.API.FAILED,
      };
    case MODEL_VIEW.REMEDIATE_MODEL:
      return {
        ...state,
        remediateModelStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.REMEDIATE_MODEL_SUCCEEDED:
      return {
        ...state,
        remediateModelStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.REMEDIATE_MODEL_FAILED:
      return {
        ...state,
        remediateModelStatus: CONSTANTS.API.FAILED,
      };
    case MODEL_VIEW.FETCH_DOWNLOAD_URL:
      return {
        ...state,
        fetchDownloadUrlStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.FETCH_DOWNLOAD_URL_SUCCEEDED:
      return {
        ...state,
        downloadUrl: action.payload,
        fetchDownloadUrlStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.FETCH_DOWNLOAD_URL_FAILED:
      return {
        ...state,
        fetchDownloadUrlError: action.payload,
        fetchDownloadUrlStatus: CONSTANTS.API.FAILED,
      };
    case MODEL_VIEW.FETCH_INPUT_DIST_DOWNLOAD_URL:
      return {
        ...state,
        [action.payload.matchType === 'pre' ? 'fetchPreMatchInputDistStatus' : 'fetchPostMatchInputDistStatus']:
          CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.FETCH_INPUT_DIST_DOWNLOAD_URL_SUCCEEDED:
      return {
        ...state,
        [`${action.payload.matchType}MatchInputDistUrl`]: action.payload.url,
        [action.payload.matchType === 'pre' ? 'fetchPreMatchInputDistStatus' : 'fetchPostMatchInputDistStatus']:
          CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.FETCH_INPUT_DIST_DOWNLOAD_URL_FAILED:
      return {
        ...state,
        [action.payload.matchType === 'pre' ? 'fetchPreMatchInputDistError' : 'fetchPostMatchInputDistError']:
          action.payload.error,
        [action.payload.matchType === 'pre' ? 'fetchPreMatchInputDistStatus' : 'fetchPostMatchInputDistStatus']:
          CONSTANTS.API.FAILED,
      };

    case MODEL_VIEW.FETCH_LIFT_CHART_DOWNLOAD_URL:
      return {
        ...state,
        fetchLiftChartDownloadUrlStatus: CONSTANTS.API.STARTED,
      };
    case MODEL_VIEW.FETCH_LIFT_CHART_DOWNLOAD_URL_SUCCEEDED:
      return {
        ...state,
        liftChartDownloadUrl: action.payload.url,
        fetchLiftChartDownloadUrlStatus: CONSTANTS.API.SUCCEEDED,
      };
    case MODEL_VIEW.FETCH_LIFT_CHART_DOWNLOAD_URL_FAILED:
      return {
        ...state,
        fetchLiftChartDownloadError: action.payload.error,
        fetchLiftChartDownloadUrlStatus: CONSTANTS.API.FAILED,
      };

    case MODEL_VIEW.SET_CHART:
      return {
        ...state,
        chart: action.payload,
      };
    case MODEL_VIEW.SET_EQUAL_TYPE:
      return {
        ...state,
        equalType: action.payload,
      };
    case MODEL_VIEW.SET_AVAILABLE_QUANTILES:
      return {
        ...state,
        availableQuantiles: action.payload,
      };
    case MODEL_VIEW.SET_QUANTILES:
      return {
        ...state,
        quantiles: action.payload,
        quantileIdx: state.availableQuantiles.current.findIndex((qn) => qn === action.payload),
      };
    case MODEL_VIEW.SET_QUANTILE_IDX:
      return {
        ...state,
        quantileIdx: action.payload,
      };
    case MODEL_VIEW.SET_GRADIENT:
      return {
        ...state,
        gradient: action.payload,
      };
    default:
      return state;
  }
};
